import { useState } from 'react'
import { useMediaQuery } from 'react-responsive'

export default function (props: PageProps) {
  const [ state, dispatch ] = useState({ open: false })

  const {
      navigator
    , location
    , store
    , params } = props

  if (useMediaQuery({ minWidth: 1280 })) {
    return <div className='min-h-screen'>
      <div className='flex justify-between items-center px-32 py-8'>
        <h1 className='font-bold text-gray-800 text-2xl'>贵州永信木创家具有限公司</h1>

        <ul className='flex justify-end items-center space-x-4 text-gray-600 text-lg'>
          <li className='hover:decoration-dashed hover:underline cursor-pointer' onClick={() => navigator.to(`/home`)}>首页</li>
          <li className='hover:decoration-dashed hover:underline cursor-pointer' onClick={() => window.open(`http://yx.snso.com/`, '_blank')}>信息化管理系统</li>
          <li className='hover:decoration-dashed hover:underline cursor-pointer' onClick={() => window.open(`https://yxc.snso.com/search`, '_blank')}>订单信息查询</li>
          <li className='hover:decoration-dashed hover:underline cursor-pointer' onClick={() => window.open(`https://yxc.snso.com/login`, '_blank')}>生产信息录入</li>
        </ul>
      </div>

      <div className='space-y-16 p-32 pb-8'>
        <div className='flex flex-col items-center space-y-4'>
          <h1 className='text-3xl'>诚信经营、品质优良、服务至上</h1>
          <h3 className='text-lg'>永信木业 是一家集板式家具、原木油漆、门墙柜一体化全屋定制工厂</h3>
        </div>

        <img src={store.assets.from(`/images/101.jpg`)} className='w-full object-contain'/>
      </div>

      <div className='space-y-16 px-32 py-24'>
        <div className='flex flex-col items-center space-y-4'>
          <h1 className='text-3xl'>精工品质让生活更美好</h1>
          <h3 className='text-lg'>量身定制专业设计，让理想家具与您相伴</h3>
        </div>

        <ul className='flex justify-center items-center space-x-6'>
          <li className='bg-gray-200 py-4 w-[10rem] text-center'>一站式服务</li>
          <li className='bg-gray-200 py-4 w-[10rem] text-center'>精工品质</li>
          <li className='bg-gray-200 py-4 w-[10rem] text-center'>量身定制</li>
          <li className='bg-gray-200 py-4 w-[10rem] text-center'>安全材质</li>
          <li className='bg-gray-200 py-4 w-[10rem] text-center'>免费配送安装</li>
          <li className='bg-gray-200 py-4 w-[10rem] text-center'>贴心售后</li>
        </ul>
      </div>

      <img src={store.assets.from(`/images/102.jpg`)} className='w-full object-contain'/>

      <footer className='flex flex-col items-center px-32 pt-24 pb-12'>
        <div className='font-bold text-lg'>贵州永信木创家具有限公司</div>
        <div className='text-base'>黔ICP备2022009741号</div>
      </footer>
    </div>
  }

  return <div className='min-h-screen'>
    <div className='top-0 z-[999] fixed inset-x-0 bg-white shadow p-4'>
      <div className='flex justify-between items-center'>
        <h1 className='font-bold text-gray-800'>贵州永信木创家具有限公司</h1>
        <div className={`text-xl ${state.open ? 'text-yellow-400' : 'text-gray-800'}`} onClick={() => dispatch({ ...state, open: !state.open })}><i className='fa fa-bars'/></div>
      </div>

      <div className='overflow-hidden text-gray-600 text-base transition-all duration-500 ease-in-out' style={{ maxHeight: state.open ? 200 : 0 }}>
        <ul className='space-y-2 mt-2 p-2 pt-6 border-gray-200 border-t'>
          <li className='active:decoration-dashed active:underline' onClick={() => navigator.to(`/home`)}>首页</li>
          <li className='active:decoration-dashed active:underline' onClick={() => window.open(`http://yx.snso.com/`, '_blank')}>信息化管理系统</li>
          <li className='active:decoration-dashed active:underline' onClick={() => window.open(`https://yxc.snso.com/search`, '_blank')}>订单信息查询</li>
          <li className='active:decoration-dashed active:underline' onClick={() => window.open(`https://yxc.snso.com/login`, '_blank')}>生产信息录入</li>
        </ul>
      </div>
    </div>

    <div className='space-y-4 mt-16 px-4 pt-8'>
      <div className='flex flex-col items-center space-y-2'>
        <h1 className='text-lg text-center'>诚信经营、品质优良、服务至上</h1>
        <h3 className='text-sm text-center'>永信木业 是一家集板式家具、原木油漆、门墙柜一体化全屋定制工厂</h3>
      </div>

      <img src={store.assets.from(`/images/101.jpg`)} className='w-full object-contain'/>
    </div>

    <div className='space-y-4 px-4 py-8'>
      <div className='flex flex-col items-center space-y-2'>
        <h1 className='text-lg text-center'>精工品质让生活更美好</h1>
        <h3 className='text-sm text-center'>量身定制专业设计，让理想家具与您相伴</h3>
      </div>
    </div>

    <img src={store.assets.from(`/images/102.jpg`)} className='w-full object-contain'/>

    <footer className='flex flex-col items-center px-4 py-8'>
      <div className='font-bold text-base'>贵州永信木创家具有限公司</div>
      <a href='https://beian.miit.gov.cn/' target='_blank'> 黔ICP备2022009741号-1</a>
    </footer>
  </div>
}
